const id = () => {
  const stamp = Date.now().toString(36).padStart(9, "0");
  return stamp + token(11);
};

const token = (length = 32) => {
  const bytes = new Uint8Array(Math.ceil((length * Math.log2(36)) / 8));
  crypto.getRandomValues(bytes);

  const num = bytes.reduce((acc, b) => acc * 256n + BigInt(b), 0n);
  return num.toString(36).padStart(length, "0").slice(0, length);
};

export const random = {
  id,
  token,
};
